var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageCardIcon13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1693_24710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0957031 2.48517V22.3402C0.0957031 23.337 0.903829 24.1452 1.9007 24.1452H16.3407H26.3041H30.7807C31.7776 24.1452 32.5857 23.337 32.5857 22.3402V11.8712V2.48518C32.5857 1.4883 31.7776 0.680176 30.7807 0.680176H16.3407H4.15695H1.9007C0.903829 0.680176 0.0957031 1.4883 0.0957031 2.48517Z",
    fill: "url(#paint0_linear_1693_24710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41082 15.9398L1.24724 20.5282C0.45788 21.3981 1.07512 22.7917 2.24977 22.7917H27.2732C28.4479 22.7917 29.0651 21.3981 28.2757 20.5282L20.2765 11.7127C19.7393 11.1207 18.8087 11.1207 18.2715 11.7127L11.9284 18.7031C11.3912 19.2951 10.4606 19.2951 9.92333 18.7031L7.41589 15.9398C6.87865 15.3477 5.94806 15.3477 5.41082 15.9398Z",
    fill: "url(#paint1_linear_1693_24710)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6987,
    cy: 13.0898,
    r: 2.48187,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0041 3.56688L30.3392 11.9979C30.51 12.2679 30.6052 12.5789 30.6147 12.8983C30.6242 13.2176 30.5478 13.5337 30.3934 13.8135C30.239 14.0932 30.0123 14.3264 29.737 14.4885C29.4617 14.6507 29.1479 14.7359 28.8283 14.7353H18.1582C17.8387 14.7359 17.5249 14.6507 17.2496 14.4885C16.9743 14.3264 16.7476 14.0932 16.5932 13.8135C16.4388 13.5337 16.3624 13.2176 16.3719 12.8983C16.3814 12.5789 16.4766 12.2679 16.6474 11.9979L21.9824 3.56688C22.1438 3.31215 22.3669 3.10234 22.631 2.95696C22.8952 2.81158 23.1918 2.73535 23.4933 2.73535C23.7948 2.73535 24.0914 2.81158 24.3556 2.95696C24.6197 3.10234 24.8428 3.31215 25.0041 3.56688Z",
    fill: "url(#paint2_linear_1693_24710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4922 13.2348C23.9064 13.2348 24.2422 12.8991 24.2422 12.4849C24.2422 12.0706 23.9064 11.7349 23.4922 11.7349C23.078 11.7349 22.7422 12.0706 22.7422 12.4849C22.7422 12.8991 23.078 13.2348 23.4922 13.2348Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.495 10.2343C23.2908 10.2344 23.0941 10.1577 22.9439 10.0194C22.7936 9.88119 22.7008 9.69153 22.6839 9.48807L22.4645 6.85523C22.4526 6.71265 22.4705 6.56916 22.5168 6.43381C22.5632 6.29846 22.6372 6.1742 22.734 6.06888C22.8308 5.96355 22.9485 5.87944 23.0794 5.82187C23.2104 5.7643 23.3519 5.7345 23.495 5.73438C23.6382 5.73435 23.7798 5.76403 23.9109 5.82153C24.042 5.87904 24.1598 5.96312 24.2567 6.06846C24.3537 6.17381 24.4277 6.29812 24.4742 6.43354C24.5206 6.56897 24.5385 6.71256 24.5266 6.85523L24.3072 9.48807C24.2903 9.69173 24.1973 9.88155 24.0468 10.0198C23.8963 10.1581 23.6993 10.2346 23.495 10.2343Z",
    fill: "#F0F2F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_24710",
    x1: -1.05816,
    y1: 4.03983,
    x2: 32.7238,
    y2: 33.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7280FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1693_24710",
    x1: 14.7615,
    y1: 10.6079,
    x2: 14.7615,
    y2: 22.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6FFFF",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1693_24710",
    x1: 20.6813,
    y1: 5.64165,
    x2: 30.0562,
    y2: 14.5478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1693_24710"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.09375,
    y: 0.680176,
    width: 32.49,
    height: 23.465,
    rx: 1.805,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCardIcon13);
export default __webpack_public_path__ + "static/media/message_card_icon13.d6f4f1fb96dd7959389b939a6847df7b.svg";
export { ForwardRef as ReactComponent };